<main class="app-shell" [class.sidebar-collapsed]="sidebarCollapsed()">
    <app-menu
            [activeView]="activeView()"
            [isCollapsed]="sidebarCollapsed()"
            (activeViewChange)="navigate($event)"
            (collapsedChange)="sidebarCollapsed.set($event)"
    ></app-menu>

    <section class="content-shell"
              #contentShell
              [class.content-shell-sem-scrollbar]="activeView() === 'pedido-venda' || activeView() === 'pre-venda' || activeView() === 'pedido-compra-form' || activeView() === 'pre-compra-form' || activeView() === 'compra-form' || activeView() === 'duplicar-produto' || activeView() === 'gpl-transferencia' || activeView() === 'estoque-separacao' || activeView() === 'estoque-conferencia' || activeView() === 'estoque-logistica' || activeView() === 'conferencia-pendente' || activeView() === 'itens-pendentes-legado' || activeView() === 'paineis-separacao' || activeView() === 'paineis-conferencia' || activeView() === 'paineis-logistica' || activeView() === 'cadastro-aeronave' || activeView() === 'comparacao-estoque' || activeView() === 'cadastro-parceiro' || activeView() === 'atividade-acessos' || activeView() === 'etiqueta-config' || activeView() === 'controle-acessos' || activeView() === 'motivo-cancelamento' || activeView() === 'gpl-parametros' || activeView() === 'gpl-regras-comissao' || activeView() === 'demonstrativo-vendas' || activeView() === 'controle-core' || activeView() === 'controle-forms' || activeView() === 'fabricantes' || activeView() === 'contas' || activeView() === 'gpl-conferencia-cliente' || activeView() === 'gpl-venda-impressao' || activeView() === 'gpl-relatorios-comissoes' || activeView() === 'gpl-relatorio-comissionamento'">


        <app-home *ngIf="activeView() === 'home'" style="flex: 1; display: flex; flex-direction: column;"></app-home>
        <app-demonstrativo-vendas *ngIf="activeView() === 'demonstrativo-vendas'" (activeViewChange)="navigate($event)"></app-demonstrativo-vendas>
        <app-controle-core *ngIf="activeView() === 'controle-core'"></app-controle-core>
        <app-controle-forms *ngIf="activeView() === 'controle-forms'"></app-controle-forms>
        <app-fabricantes *ngIf="activeView() === 'fabricantes'"></app-fabricantes>
        <app-contas *ngIf="activeView() === 'contas'"></app-contas>
        <app-gpl-holerites *ngIf="activeView() === 'gpl-holerites'"></app-gpl-holerites>
        <app-gpl-transferencia *ngIf="activeView() === 'gpl-transferencia'"></app-gpl-transferencia>
        <app-gpl-regras-comissao *ngIf="activeView() === 'gpl-regras-comissao'"></app-gpl-regras-comissao>
        <app-produtos-lista *ngIf="activeView() === 'lista-produtos'" (novoProduto)="onNovoProdutoDaLista($event)" (editarProduto)="onIrParaEdicaoProduto($event, 'lista-produtos')" (clonarProduto)="onClonarProduto($event, 'lista-produtos')"></app-produtos-lista>
        <app-duplicar-produto *ngIf="activeView() === 'duplicar-produto'" [origemCadastro]="produtoCadastroOrigemLista() ? 'lista-produtos' : null" [pnAutoPreencher]="produtoCadastroAutoPreencherPN()" (pnAutoPreencherConsumido)="onProdutoCadastroAutoPreencherConsumido()" [produtoClonar]="produtoCadastroClonar()" (produtoClonarConsumido)="onProdutoCadastroClonarConsumido()" [origemClone]="produtoCadastroClonarOrigem()" (voltarOrigem)="onVoltarDoCadastroClonado($event)" (irParaEdicao)="onIrParaEdicaoProduto($event)"></app-duplicar-produto>
        <app-gpl-edicao-produtos *ngIf="activeView() === 'gpl-edicaodeprodutos'" [codProdAutoAbrir]="produtoEdicaoAutoAbrir()" [origemEdicao]="produtoEdicaoOrigem()" (voltarOrigem)="onVoltarDaEdicaoProduto()" (codProdAutoAbrirConsumido)="onProdutoEdicaoAutoAbrirConsumido()" (clonarProduto)="onClonarProduto($event, 'gpl-edicaodeprodutos')" (irParaCadastro)="onIrParaCadastroProduto($event)"></app-gpl-edicao-produtos>

        <app-gpl-venda-impressao
                *ngIf="activeView() === 'gpl-venda-impressao'"
                (activeViewChange)="navigate($event)">
        </app-gpl-venda-impressao>
        <app-compra-impressao
                *ngIf="activeView() === 'impressao-pre-compra' || activeView() === 'impressao-pre-compra-dolar' || activeView() === 'impressao-compra-internacional' || activeView() === 'impressao-compra-lista' || activeView() === 'impressao-pedido-compra'"
                [view]="activeView()">
        </app-compra-impressao>
        <app-gpl-conferencia-cliente
                *ngIf="activeView() === 'gpl-conferencia-cliente'">
        </app-gpl-conferencia-cliente>

        <app-pedido-venda-lista #listaComp
                [hidden]="activeView() !== 'pedido-venda-lista'"
                (novoPedido)="onNovoPedido()"
                (editarPedido)="onEditarPedido($event)"
                (imprimirPedido)="onImprimirPedido($event)"
                (solicitarDuplicar)="onSolicitarDuplicarPedido($event)"
                (solicitarDividir)="onSolicitarDividirPedido($event)"
                (solicitarTransferir)="onSolicitarTransferirPedido($event)"
                (solicitarFluxo)="onSolicitarFluxoPedido($event)"
                (solicitarTransporte)="onSolicitarTransportePedido($event)"
                (solicitarAnexos)="onSolicitarAnexos($event)"
                (solicitarAutorizar)="onSolicitarAutorizarPedido($event)"
                (avisoAutorizarBloqueado)="mostrarToast($event, 9000)"
                (solicitarGerarPedidoCompra)="onSolicitarGerarPedidoCompra($event)"
                (solicitarGerarVendaOS)="onSolicitarGerarVendaOS()"
                (solicitarGerarVendaLegado)="onSolicitarGerarVendaLegado()"
                (solicitarAlterarStatusGpl)="onSolicitarAlterarStatus($event)">
        </app-pedido-venda-lista>
        <app-pedido-venda
                *ngIf="activeView() === 'pedido-venda' || (acaoStatusImportar() !== null && !modoPreVenda())"
                [hidden]="acaoStatusImportar() !== null"
                [nunotaEditar]="pedidoEditando()"
                [itensImportadosDeOS]="itensImportarDeOS()"
                [observacaoInicial]="observacaoImportarDeOS()"
                [origemOS]="origemOSImportar()"
                [acaoStatusPendente]="acaoStatusImportar()"
                (voltarLista)="onVoltarLista()"
                (osVendaGravada)="onOsVendaGravada($event)"
                (acaoStatusConcluida)="onAcaoStatusConcluida($event)">
        </app-pedido-venda>
        <app-pre-venda-lista #preListaComp
                [hidden]="activeView() !== 'pre-venda-lista'"
                (mensagem)="mostrarToast($event, 9000)"
                (novoPedido)="onNovoPedido()"
                (editarPedido)="onEditarPedido($event)"
                (imprimirPedido)="onImprimirPedido($event)"
                (solicitarDuplicar)="onSolicitarDuplicarPedido($event)"
                (solicitarDividir)="onSolicitarDividirPedido($event)"
                (solicitarTransferir)="onSolicitarTransferirPedido($event)"
                (solicitarFluxo)="onSolicitarFluxoPedido($event)"
                (solicitarTransporte)="onSolicitarTransportePedido($event)"
                (solicitarAnexos)="onSolicitarAnexos($event)"
                (solicitarAutorizar)="onSolicitarAutorizarPedido($event)"
                (avisoAutorizarBloqueado)="mostrarToast($event, 9000)"
                (solicitarGerarPedidoCompra)="onSolicitarGerarPedidoCompra($event)"
                (solicitarGerarVendaOS)="onSolicitarGerarVendaOS()"
                (solicitarGerarVendaLegado)="onSolicitarGerarVendaLegado()"
                (solicitarAlterarStatusGpl)="onSolicitarAlterarStatus($event)">
        </app-pre-venda-lista>
        <app-pre-venda
                *ngIf="activeView() === 'pre-venda' || (acaoStatusImportar() !== null && modoPreVenda())"
                [hidden]="acaoStatusImportar() !== null"
                [nunotaEditar]="pedidoEditando()"
                [itensImportadosDeOS]="itensImportarDeOS()"
                [observacaoInicial]="observacaoImportarDeOS()"
                [origemOS]="origemOSImportar()"
                [acaoStatusPendente]="acaoStatusImportar()"
                (voltarLista)="onVoltarLista()"
                (osVendaGravada)="onOsVendaGravada($event)"
                (acaoStatusConcluida)="onAcaoStatusConcluida($event)">
        </app-pre-venda>
        <app-motivo-cancelamento
                *ngIf="activeView() === 'motivo-cancelamento'">
        </app-motivo-cancelamento>
        <app-parametro
                *ngIf="activeView() === 'gpl-parametros'">
        </app-parametro>
        <app-etiqueta-config
                *ngIf="activeView() === 'etiqueta-config'"
                style="flex:1;display:flex;flex-direction:column;overflow:hidden">
        </app-etiqueta-config>
        <app-controle-acessos
                *ngIf="activeView() === 'controle-acessos'">
        </app-controle-acessos>
        <app-atividade-acessos
                *ngIf="activeView() === 'atividade-acessos'">
        </app-atividade-acessos>
        <app-gpl-manual *ngIf="activeView() === 'gpl-manual'"></app-gpl-manual>
        <app-gpl-relatorios-comissoes *ngIf="activeView() === 'gpl-relatorios-comissoes'"></app-gpl-relatorios-comissoes>
        <app-gpl-relatorio-comissionamento *ngIf="activeView() === 'gpl-relatorio-comissionamento'"></app-gpl-relatorio-comissionamento>
        <app-paineis-separacao *ngIf="activeView() === 'paineis-separacao'" style="flex:1;display:flex;flex-direction:column;"></app-paineis-separacao>
        <app-paineis-conferencia *ngIf="activeView() === 'paineis-conferencia'" style="flex:1;display:flex;flex-direction:column;"></app-paineis-conferencia>
        <app-paineis-logistica *ngIf="activeView() === 'paineis-logistica'" style="flex:1;display:flex;flex-direction:column;"></app-paineis-logistica>
        <app-estoque-separacao
                *ngIf="activeView() === 'estoque-separacao'"
                style="flex:1;display:flex;flex-direction:column;"
                (iniciar)="onIniciarSeparacao($event)"
                (iniciarLegado)="onIniciarSeparacaoLegado($event)">
        </app-estoque-separacao>
        <app-estoque-separacao-itens
                *ngIf="activeView() === 'estoque-separacao-itens'"
                [nunota]="separacaoNunota()!"
                (voltar)="onVoltarSeparacaoLista()"
                (finalizado)="onSeparacaoFinalizada()"
                style="flex:1;display:flex;flex-direction:column;">
        </app-estoque-separacao-itens>
        <!-- Continuar Separação — vendas do Sistema Legado (Aerosys). Tela isolada,
             sem validação de posse (ver estoque-separacao-itens-legado.component.ts). -->
        <app-estoque-separacao-itens-legado
                *ngIf="activeView() === 'estoque-separacao-itens-legado'"
                [idVenda]="separacaoLegadoIdVenda()!"
                [numVenda]="separacaoLegadoNumVenda()"
                (voltar)="onVoltarSeparacaoLegadoLista()"
                (finalizado)="onSeparacaoLegadoFinalizada()"
                style="flex:1;display:flex;flex-direction:column;">
        </app-estoque-separacao-itens-legado>
        <app-estoque-conferencia
                *ngIf="activeView() === 'estoque-conferencia'"
                style="flex:1;display:flex;flex-direction:column;"
                (iniciar)="onIniciarConferencia($event)"
                (iniciarLegado)="onIniciarConferenciaLegado($event)"
                (finalizado)="onConferenciaFinalizada()">
        </app-estoque-conferencia>
        <app-estoque-conferencia-itens
                *ngIf="activeView() === 'estoque-conferencia-itens'"
                [nunota]="conferenciaNunota()!"
                (voltar)="onVoltarConferenciaLista()"
                (finalizado)="onConferenciaFinalizada()"
                (pendenciaEnviada)="onPendenciaEnviada()"
                (solicitarFinalizarComStatus)="onSolicitarFinalizarConferenciaComStatus($event)"
                style="flex:1;display:flex;flex-direction:column;">
        </app-estoque-conferencia-itens>
        <!-- Continuar Conferência — vendas do Sistema Legado (Aerosys). Tela isolada,
             sem validação de posse (ver estoque-conferencia-itens-legado.component.ts). -->
        <app-estoque-conferencia-itens-legado
                *ngIf="activeView() === 'estoque-conferencia-itens-legado'"
                [idVenda]="conferenciaLegadoIdVenda()!"
                [numVenda]="conferenciaLegadoNumVenda()"
                (voltar)="onVoltarConferenciaLegadoLista()"
                (finalizado)="onConferenciaLegadoFinalizada()"
                style="flex:1;display:flex;flex-direction:column;">
        </app-estoque-conferencia-itens-legado>
        <app-estoque-logistica
                *ngIf="activeView() === 'estoque-logistica'"
                style="flex:1;display:flex;flex-direction:column;"
                (visualizarItens)="onVisualizarItensLogistica($event)">
        </app-estoque-logistica>
        <app-estoque-logistica-itens
                *ngIf="activeView() === 'estoque-logistica-itens'"
                [nunota]="logisticaNunota()!"
                (voltar)="onVoltarLogisticaLista()"
                (finalizado)="onLogisticaFinalizada()"
                style="flex:1;display:flex;flex-direction:column;">
        </app-estoque-logistica-itens>
        <app-conferencia-pendente
                *ngIf="activeView() === 'conferencia-pendente'"
                style="flex:1;display:flex;flex-direction:column;"
                (verItens)="onVerItensPendencia($event)">
        </app-conferencia-pendente>
        <app-conferencia-pendente-itens
                *ngIf="activeView() === 'conferencia-pendente-itens'"
                [nunota]="pendenciaVendedorNunota()!"
                (voltar)="onVoltarPendenciaLista()"
                (resolvido)="onPendenciaResolvida()"
                (editarVenda)="onEditarVendaDePendencia($event)"
                style="flex:1;display:flex;flex-direction:column;">
        </app-conferencia-pendente-itens>
        <app-itens-pendentes-legado
                *ngIf="activeView() === 'itens-pendentes-legado'"
                style="flex:1;display:flex;flex-direction:column;">
        </app-itens-pendentes-legado>
        <app-comparacao-estoque
                *ngIf="activeView() === 'comparacao-estoque'"
                style="flex:1;display:flex;flex-direction:column;">
        </app-comparacao-estoque>
        <app-parceiros-lista *ngIf="activeView() === 'cadastro-parceiro' && !parceiroCadastroAberto()" (novoParceiro)="parceiroEdicaoDoc.set(null); parceiroEdicaoCod.set(null); parceiroNovoDoc.set(null); parceiroNovoNome.set(null); parceiroCadastroAberto.set(true)" (cadastrarDoAerosys)="parceiroEdicaoDoc.set(null); parceiroEdicaoCod.set(null); parceiroNovoDoc.set($event.doc); parceiroNovoNome.set($event.nome); parceiroCadastroAberto.set(true)" (editarParceiro)="parceiroEdicaoDoc.set($event.doc); parceiroEdicaoCod.set($event.codparc); parceiroNovoDoc.set(null); parceiroNovoNome.set(null); parceiroCadastroAberto.set(true)"></app-parceiros-lista>
        <app-cadastro-parceiro *ngIf="activeView() === 'cadastro-parceiro' && parceiroCadastroAberto()" [docParceiroEdicao]="parceiroEdicaoDoc()" [codParcEdicao]="parceiroEdicaoCod()" [docParceiroNovo]="parceiroNovoDoc()" [nomeParceiroNovo]="parceiroNovoNome()" (salvo)="parceiroCadastroAberto.set(false)" (voltar)="parceiroCadastroAberto.set(false)"></app-cadastro-parceiro>
        <!-- TODO: componente 'cadastro-aeronave' ainda não implementado (ver gateway.component.ts) -->
        <app-aeronaves-lista *ngIf="activeView() === 'cadastro-aeronave' && !aeronaveCadastroAberto()" (novaAeronave)="aeronaveEdicaoPrefixo.set(null); aeronaveCadastroAberto.set(true)" (editarAeronave)="aeronaveEdicaoPrefixo.set($event.prefixo); aeronaveCadastroAberto.set(true)"></app-aeronaves-lista>
        <app-cadastro-aeronave *ngIf="activeView() === 'cadastro-aeronave' && aeronaveCadastroAberto()" [prefixoEdicao]="aeronaveEdicaoPrefixo()" (salvo)="aeronaveCadastroAberto.set(false)" (voltar)="aeronaveCadastroAberto.set(false)"></app-cadastro-aeronave>
        <app-nota-control-teste *ngIf="activeView() === 'nota-control-teste'"></app-nota-control-teste>
        <app-consultar-ipi *ngIf="activeView() === 'consultar-ipi'"></app-consultar-ipi>
        <app-download-xml-compra *ngIf="activeView() === 'download-xml-compra'"></app-download-xml-compra>
        <app-liberacao-lista *ngIf="activeView() === 'liberacao'" style="flex:1;display:flex;flex-direction:column;"></app-liberacao-lista>
        <app-pedido-compra *ngIf="activeView() === 'pedido-compra'"
          style="flex:1;display:flex;flex-direction:column;"
          (novoPedido)="onNovoPedidoCompra()"
          (editarPedido)="onEditarPedidoCompra($event)"
          (imprimirPedido)="onImprimirCompra($event)">
        </app-pedido-compra>
        <app-pedido-compra-form *ngIf="activeView() === 'pedido-compra-form'"
          style="flex:1;display:flex;flex-direction:column;"
          [nunotaEditar]="pedidoCompraEditando()"
          (abaItensChange)="pedidoCompraAbaItens.set($event)"
          (voltarLista)="onVoltarListaCompra()">
        </app-pedido-compra-form>
        <app-pre-compra-lista *ngIf="activeView() === 'pre-compra-lista'"
          style="flex:1;display:flex;flex-direction:column;"
          (novoPedido)="onNovaPreCompra()"
          (editarPedido)="onEditarPreCompra($event)"
          (imprimirPedido)="onImprimirCompra($event)">
        </app-pre-compra-lista>
        <div *ngIf="tipoPreCompraModalAberto()" (click)="tipoPreCompraModalAberto.set(false)"
             style="position:fixed;inset:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:5000;">
          <div (click)="$event.stopPropagation()"
               style="background:#fff;border-radius:14px;padding:26px 30px;width:380px;max-width:92vw;box-shadow:0 20px 50px rgba(0,0,0,.25);text-align:center;">
            <h3 style="margin:0 0 6px;font-size:17px;color:#0f172a;">Nova Pré-Compra</h3>
            <p style="margin:0 0 18px;font-size:13px;color:#475569;">Qual é o tipo da pré-compra?</p>
            <div style="display:flex;gap:12px;justify-content:center;">
              <button type="button" (click)="escolherTipoNovaPreCompra('NACIONAL')"
                style="flex:1;padding:12px 8px;border-radius:10px;border:1px solid #93c5fd;background:#dbeafe;color:#1e3a8a;font-weight:700;cursor:pointer;">
                NACIONAL<br><span style="font-size:11px;font-weight:500;">Empresa 1</span>
              </button>
              <button type="button" (click)="escolherTipoNovaPreCompra('IMPORTACAO')"
                style="flex:1;padding:12px 8px;border-radius:10px;border:1px solid #c4b5fd;background:#d9c7f2;color:#4c1d95;font-weight:700;cursor:pointer;">
                IMPORTAÇÃO<br><span style="font-size:11px;font-weight:500;">Empresa 12</span>
              </button>
            </div>
            <button type="button" (click)="tipoPreCompraModalAberto.set(false)"
              style="margin-top:16px;background:none;border:none;color:#64748b;cursor:pointer;font-size:12px;">Cancelar</button>
          </div>
        </div>
        <app-pre-compra-form *ngIf="activeView() === 'pre-compra-form'"
          style="flex:1;display:flex;flex-direction:column;"
          [nunotaEditar]="preCompraEditando()"
          [tipoInicial]="preCompraTipoNovo()"
          (abaItensChange)="preCompraAbaItens.set($event)"
          (voltarLista)="onVoltarPreCompra()">
        </app-pre-compra-form>
        <app-compra-lista *ngIf="activeView() === 'compra-lista'"
          style="flex:1;display:flex;flex-direction:column;"
          (novoPedido)="onNovaCompra()"
          (editarPedido)="onEditarCompra($event)"
          (imprimirPedido)="onImprimirCompra($event)">
        </app-compra-lista>
        <app-compra-form *ngIf="activeView() === 'compra-form'"
          style="flex:1;display:flex;flex-direction:column;"
          [nunotaEditar]="compraEditando()"
          (abaItensChange)="compraAbaItens.set($event)"
          (voltarLista)="onVoltarCompra()">
        </app-compra-form>
    </section>

    <!-- Setas flutuantes "mais conteúdo" (substituem a barra de rolagem nativa
         — só na tela de Pedido de Venda, pedido do usuário)
         OCULTADAS TEMPORARIAMENTE a pedido do usuário (*ngIf="false" abaixo) —
         código mantido intacto pra reativar depois só tirando o "false &&". -->
    <button type="button" class="scroll-seta scroll-seta-cima"
            *ngIf="false && activeView() === 'pedido-venda' && mostrarSetaScrollCima()"
            title="Rolar para cima — há mais informações acima"
            (click)="rolarContentShell('cima')">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15"/>
      </svg>
    </button>
    <button type="button" class="scroll-seta scroll-seta-baixo"
            *ngIf="false && activeView() === 'pedido-venda' && mostrarSetaScrollBaixo()"
            title="Rolar para baixo — há mais informações abaixo"
            (click)="rolarContentShell('baixo')">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </button>

<!-- ── Modal Duplicar Venda (nível raiz, fora do content-shell) ── -->
<div class="dup-overlay" *ngIf="modalDuplicarAberto" (click)="fecharModalDuplicar()">
  <div class="dup-modal" (click)="$event.stopPropagation()">

    <div class="dup-icone">
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
      </svg>
    </div>

    <div class="dup-titulo">Clonar Venda</div>
    <div class="dup-subtitulo">
      <ng-container *ngIf="duplicarStep === 1">
        Selecione a empresa de destino para clonar o pedido <strong>#{{ duplicarNunota }}</strong>.
      </ng-container>
      <ng-container *ngIf="duplicarStep === 2">
        Escolha quais itens do pedido <strong>#{{ duplicarNunota }}</strong> serão incluídos na clonagem.
      </ng-container>
    </div>

    <div *ngIf="duplicarErro" class="dup-erro">{{ duplicarErro }}</div>

    <!-- Step 1: seleção de empresa -->
    <div *ngIf="duplicarStep === 1" class="dup-empresas-wrap">
      <label class="dup-label">Empresa de destino</label>
      <div class="dup-empresas-grid">
        <button *ngFor="let e of duplicarEmpresasOpcoes"
                type="button"
                class="dup-empresa-card"
                [class.dup-empresa-card--ativa]="empDuplicarSelecionada === e.codEmp"
                [style.background]="empresaState.corClaraPorCodEmp(e.codEmp, 0.80)"
                [style.border-color]="empDuplicarSelecionada === e.codEmp ? empresaState.corPorCodEmp(e.codEmp) : 'transparent'"
                (click)="empDuplicarSelecionada = e.codEmp"
                [disabled]="duplicarCarregando || duplicarItensCarregando">
          <span class="dup-emp-dot" [style.background]="empresaState.corPorCodEmp(e.codEmp)"></span>
          <span class="dup-emp-cod">{{ e.codEmp }}</span>
          <span class="dup-emp-nome">{{ e.nomeFant || e.razaoAbrev }}</span>
        </button>
      </div>
    </div>

    <!-- Step 2: seleção de itens -->
    <div *ngIf="duplicarStep === 2" class="dup-itens-wrap">
      <div class="dup-itens-header">
        <label class="dup-label" style="margin:0">Itens do pedido</label>
        <label class="dup-check-todos">
          <input type="checkbox"
                 [checked]="duplicarTodosSelecionados"
                 (change)="toggleTodosItens($any($event.target).checked)"
                 [disabled]="duplicarCarregando">
          <span>Todos</span>
        </label>
      </div>
      <div class="dup-itens-lista">
        <label *ngFor="let item of duplicarItens" class="dup-item-row">
          <input type="checkbox" [(ngModel)]="item.selecionado" [disabled]="duplicarCarregando">
          <span class="dup-item-info">
            <span class="dup-item-linha1">
              <span *ngIf="item.refforn" class="dup-campo">
                <span class="dup-lbl">PN</span>
                <span class="dup-val">{{ item.refforn }}</span>
              </span>
              <span *ngIf="item.condicao" class="dup-campo">
                <span class="dup-lbl">CD</span>
                <span class="dup-val">{{ item.condicao }}</span>
              </span>
              <span class="dup-campo">
                <span class="dup-lbl">Descrição</span>
                <span class="dup-val">{{ item.descricao }}</span>
              </span>
            </span>
            <span class="dup-item-meta">Cód. {{ item.codprod }} &nbsp;·&nbsp; Qtd: {{ item.qtd }}</span>
          </span>
        </label>
      </div>
    </div>

    <div class="dup-acoes">
      <button type="button" class="dup-btn-cancelar"
              (click)="fecharModalDuplicar()"
              [disabled]="duplicarCarregando || duplicarItensCarregando">
        Cancelar
      </button>
      <button type="button" class="dup-btn-confirmar"
              (click)="confirmarDuplicar()"
              [disabled]="duplicarCarregando || duplicarItensCarregando || !empDuplicarSelecionada">
        <app-loading-indicator *ngIf="duplicarCarregando || duplicarItensCarregando" size="inline"></app-loading-indicator>
        <ng-container *ngIf="!duplicarCarregando && !duplicarItensCarregando">
          {{ duplicarStep === 2 ? 'Clonar' : 'Próximo' }}
        </ng-container>
        <ng-container *ngIf="duplicarCarregando">Clonando...</ng-container>
        <ng-container *ngIf="duplicarItensCarregando && !duplicarCarregando">Carregando...</ng-container>
      </button>
    </div>

  </div>
</div>

<!-- ── Modal Gerar Pedido de Compra a partir da Venda ── -->
<div class="div-overlay" *ngIf="modalGerarCompraAberto" (click)="fecharModalGerarCompra()">
  <div class="div-modal div-modal-qtd" (click)="$event.stopPropagation()">

    <div class="div-header">
      <div class="div-icone" style="background:#eff6ff;color:#2563eb;">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
        </svg>
      </div>
      <div>
        <div class="div-titulo">Gerar Pedido de Compra{{ gerarCompraNunotaOrigem ? ' — Venda #' + gerarCompraNunotaOrigem : '' }}</div>
        <div class="div-subtitulo">{{ gerarCompraStep === 1 ? 'Passo 1 de 2 — escolha a empresa' : 'Passo 2 de 2 — itens e quantidades' }}</div>
      </div>
      <button class="div-fechar" (click)="fecharModalGerarCompra()" [disabled]="gerarCompraSalvando">✕</button>
    </div>

    <div *ngIf="gerarCompraErro" class="div-alerta div-alerta-erro">{{ gerarCompraErro }}</div>

    <!-- Passo 1: empresa em que o Pedido de Compra será gerado -->
    <div *ngIf="gerarCompraStep === 1" class="dup-empresas-wrap">
      <label class="dup-label">Gerar na empresa</label>
      <div class="dup-empresas-grid">
        <button *ngFor="let e of gerarCompraEmpresasOpcoes" type="button" class="dup-empresa-card"
                [class.dup-empresa-card--ativa]="gerarCompraEmpresaSel === e.codEmp"
                [style.background]="empresaState.corClaraPorCodEmp(e.codEmp, 0.80)"
                [style.border-color]="gerarCompraEmpresaSel === e.codEmp ? empresaState.corPorCodEmp(e.codEmp) : 'transparent'"
                (click)="gerarCompraEmpresaSel = e.codEmp" [disabled]="gerarCompraSalvando">
          <span class="dup-emp-dot" [style.background]="empresaState.corPorCodEmp(e.codEmp)"></span>
          <span class="dup-emp-cod">{{ e.codEmp }}</span>
          <span class="dup-emp-nome">{{ e.nomeFant || e.razaoAbrev }}</span>
        </button>
      </div>
    </div>

    <div *ngIf="gerarCompraStep === 2 && gerarCompraCarregando" class="div-loading">
      <app-loading-indicator size="inline"></app-loading-indicator>
      Carregando itens...
    </div>

    <div *ngIf="gerarCompraStep === 2 && !gerarCompraCarregando && gerarCompraItens.length > 0" class="div-tabela-wrap">
      <table class="div-tabela">
        <thead>
          <tr>
            <th style="width:34px;">
              <input type="checkbox"
                     [checked]="gerarCompraQtdSelecionados === gerarCompraItens.length"
                     (change)="toggleSelecionarTodosGerarCompra($any($event.target).checked)">
            </th>
            <th class="div-th-pn">PN</th>
            <th class="div-th-cd">CD</th>
            <th class="div-th-prod">Descrição</th>
            <th class="div-th-num">Quantidade</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of gerarCompraItens">
            <td style="text-align:center;"><input type="checkbox" [(ngModel)]="item.selecionado"></td>
            <td class="div-td-pn">{{ item.refforn || '—' }}</td>
            <td class="div-td-cd">{{ item.condicao || '—' }}</td>
            <td class="div-td-prod">
              <span class="div-item-desc">{{ item.descricao }}</span>
              <span class="div-item-meta">Cód. {{ item.codprod }}</span>
            </td>
            <td class="div-td-num">
              <input type="number" class="div-qtd-input"
                     [(ngModel)]="item.qtd"
                     min="0.001" step="1"
                     [disabled]="!item.selecionado"
                     (focus)="$any($event.target).select()">
            </td>
          </tr>
        </tbody>
      </table>

      <div class="div-resumo">
        <strong>{{ gerarCompraQtdSelecionados }}</strong>
        {{ gerarCompraQtdSelecionados === 1 ? 'item selecionado' : 'itens selecionados' }}
      </div>
    </div>

    <div class="div-acoes">
      <button *ngIf="gerarCompraStep === 1" type="button" class="dup-btn-cancelar" (click)="fecharModalGerarCompra()" [disabled]="gerarCompraSalvando">Cancelar</button>
      <button *ngIf="gerarCompraStep === 1" type="button" class="div-btn-confirmar"
              (click)="gerarCompraStep = 2" [disabled]="!gerarCompraEmpresaSel">Continuar</button>
      <button *ngIf="gerarCompraStep === 2" type="button" class="dup-btn-cancelar" (click)="gerarCompraStep = 1" [disabled]="gerarCompraSalvando">Voltar</button>
      <button *ngIf="gerarCompraStep === 2" type="button" class="div-btn-confirmar"
              (click)="confirmarGerarPedidoCompra()"
              [disabled]="gerarCompraCarregando || gerarCompraSalvando || gerarCompraQtdSelecionados === 0">
        <app-loading-indicator *ngIf="gerarCompraSalvando" size="inline"></app-loading-indicator>
        {{ gerarCompraSalvando ? 'Gerando...' : 'Gerar Pedido de Compra' }}
      </button>
    </div>

  </div>
</div>

<!-- ── Modal Gerar Venda a Partir da O.S (bem grande: empresa por cor -> lista de OS) ── -->
<div class="div-overlay" *ngIf="modalOsAberto" (click)="fecharModalOs()">
  <div class="div-modal div-modal-os" [class.div-modal-os-compacta]="osStep === 1" (click)="$event.stopPropagation()">

    <div class="div-header">
      <div class="div-icone" style="background:#eff6ff;color:#2563eb;">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
        </svg>
      </div>
      <div>
        <div class="div-titulo">Gerar Venda a Partir da O.S</div>
        <div class="div-subtitulo">
          <ng-container *ngIf="osStep === 1">Selecione a empresa para listar as Ordens de Serviço.</ng-container>
          <ng-container *ngIf="osStep === 2">
            Ordens de Serviço de
            <strong class="os-empresa-nome-chip"
                    [style.background]="corOsEmpresaClara(osEmpresaSelecionada?.id)"
                    [style.color]="corOsEmpresa(osEmpresaSelecionada?.id)"
                    [style.border-color]="corOsEmpresa(osEmpresaSelecionada?.id)">
              {{ osEmpresaSelecionada?.nome || osEmpresaSelecionada?.razao }}
            </strong>
          </ng-container>
        </div>
      </div>
      <button class="div-fechar div-fechar-topo" (click)="fecharModalOs()" [disabled]="osCarregando">✕</button>
    </div>

    <!-- Step 1: seleção de empresa (por cor) -->
    <div *ngIf="osStep === 1" class="os-empresas-bloco">
      <div *ngIf="osEmpresasErro" class="div-alerta div-alerta-erro">{{ osEmpresasErro }}</div>

      <div *ngIf="osEmpresasCarregando" class="div-loading">
        <app-loading-indicator size="inline"></app-loading-indicator>
        Carregando empresas...
      </div>

      <div *ngIf="!osEmpresasCarregando && !osEmpresasErro && osEmpresas.length === 0" class="div-loading">
        Nenhuma empresa encontrada no Aerosys.
      </div>

      <div *ngIf="!osEmpresasCarregando && osEmpresas.length > 0" class="os-empresas-grid">
        <button *ngFor="let e of osEmpresas"
                type="button"
                class="os-empresa-card"
                [style.background]="corOsEmpresaClara(e.id)"
                [style.border-color]="corOsEmpresa(e.id)"
                (click)="selecionarOsEmpresa(e)">
          <span class="os-empresa-dot" [style.background]="corOsEmpresa(e.id)"></span>
          <span class="os-empresa-info">
            <span class="os-empresa-nome">{{ e.nome || e.razao || ('Empresa ' + e.id) }}</span>
            <span class="os-empresa-cnpj" *ngIf="e.cnpj">{{ e.cnpj }}</span>
          </span>
        </button>
      </div>
    </div>

    <!-- Step 2: lista de OS da empresa selecionada -->
    <div *ngIf="osStep === 2" class="os-lista-bloco">
      <div class="os-filtros">
        <button type="button" class="os-voltar-btn" (click)="voltarOsEmpresas()" [disabled]="osCarregando">
          ← Trocar empresa
        </button>
        <div class="os-filtro-campo os-filtro-busca">
          <label>Buscar (Cliente, Status, Aeronave, Nº O.S, Tipo)</label>
          <input type="text" class="dup-input" [(ngModel)]="osFiltroTexto" placeholder="Digite para filtrar...">
        </div>
        <div class="os-filtro-campo">
          <label>Data inicial</label>
          <input type="date" class="dup-input" [(ngModel)]="osStartDate" [disabled]="osCarregando">
        </div>
        <div class="os-filtro-campo">
          <label>Data final</label>
          <input type="date" class="dup-input" [(ngModel)]="osEndDate" [disabled]="osCarregando">
        </div>
        <button type="button" class="div-btn-confirmar"
                (click)="buscarOrdensServico()" [disabled]="osCarregando"><app-loading-indicator *ngIf="osCarregando" size="inline"></app-loading-indicator>
          {{ osCarregando ? 'Buscando...' : 'Buscar' }}
        </button>
      </div>

      <div *ngIf="osErro" class="div-alerta div-alerta-erro">{{ osErro }}</div>

      <div *ngIf="osCarregando" class="div-loading">
        <app-loading-indicator size="inline"></app-loading-indicator>
        Carregando Ordens de Serviço...
      </div>

      <div *ngIf="!osCarregando && !osErro && osLista.length === 0" class="div-loading">
        Nenhuma O.S encontrada no período selecionado.
      </div>

      <div *ngIf="!osCarregando && osLista.length > 0 && osListaFiltrada.length === 0" class="div-loading">
        Nenhuma O.S encontrada para o filtro "{{ osFiltroTexto }}".
      </div>

      <div *ngIf="!osCarregando && osListaFiltrada.length > 0" class="os-tabela-wrap">
        <table class="div-tabela">
          <thead>
            <tr>
              <th class="div-th-num">Nº O.S</th>
              <th class="div-th-cd">Tipo</th>
              <th class="div-th-cd">Status</th>
              <th class="div-th-cd">Emissão</th>
              <th class="div-th-prod">Cliente</th>
              <th class="div-th-cd">Aeronave</th>
              <th class="div-th-num div-th-valor">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let os of osListaFiltrada" class="os-linha-clicavel"
                [class.os-linha-desabilitada]="osDetalheCarregando"
                [class.os-linha-cancelada]="isOsCancelada(os.status)"
                [title]="isOsCancelada(os.status) ? 'O.S. cancelada — não é possível gerar venda' : ''"
                (click)="!osDetalheCarregando && !isOsCancelada(os.status) && onSelecionarOrdemServico(os)">
              <td class="div-td-num">{{ os.numOs || os.id }}</td>
              <td class="div-td-cd">{{ os.tipo || '—' }}</td>
              <td class="div-td-cd"><span class="os-status-badge" [style.background]="corOsStatus(os.status)">{{ os.status || '—' }}</span></td>
              <td class="div-td-cd">{{ os.dataEmissao ? (os.dataEmissao | date:'dd/MM/yyyy') : '—' }}</td>
              <td class="div-td-prod">{{ os.clienteNome || '—' }}</td>
              <td class="div-td-cd">{{ os.aeronaveMatricula || '—' }}</td>
              <td class="div-td-num div-td-valor">{{ os.totalGeral != null ? (os.totalGeral | currency:'BRL':'symbol':'1.2-2':'pt-BR') : '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>

<!-- ── Modal Gerar Venda a Partir de Sistema Legado (Aerosys — Vendas) ── -->
<div class="div-overlay" *ngIf="modalVendaLegadoAberto" (click)="fecharModalVendaLegado()">
  <div class="div-modal div-modal-os" [class.div-modal-os-compacta]="vendaLegadoStep === 1" (click)="$event.stopPropagation()">

    <div class="div-header">
      <div class="div-icone" style="background:#eff6ff;color:#2563eb;">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
        </svg>
      </div>
      <div>
        <div class="div-titulo">Gerar Venda a Partir de Sistema Legado</div>
        <div class="div-subtitulo">
          <ng-container *ngIf="vendaLegadoStep === 1">Selecione a empresa para listar as Vendas.</ng-container>
          <ng-container *ngIf="vendaLegadoStep === 2">
            Vendas de
            <strong class="os-empresa-nome-chip"
                    [style.background]="corOsEmpresaClara(vendaLegadoEmpresaSelecionada?.id)"
                    [style.color]="corOsEmpresa(vendaLegadoEmpresaSelecionada?.id)"
                    [style.border-color]="corOsEmpresa(vendaLegadoEmpresaSelecionada?.id)">
              {{ vendaLegadoEmpresaSelecionada?.nome || vendaLegadoEmpresaSelecionada?.razao }}
            </strong>
          </ng-container>
        </div>
      </div>
      <button class="div-fechar div-fechar-topo" (click)="fecharModalVendaLegado()" [disabled]="vendaLegadoCarregando">✕</button>
    </div>

    <!-- Step 1: seleção de empresa (por cor) -->
    <div *ngIf="vendaLegadoStep === 1" class="os-empresas-bloco">
      <div *ngIf="vendaLegadoEmpresasErro" class="div-alerta div-alerta-erro">{{ vendaLegadoEmpresasErro }}</div>

      <div *ngIf="vendaLegadoEmpresasCarregando" class="div-loading">
        <app-loading-indicator size="inline"></app-loading-indicator>
        Carregando empresas...
      </div>

      <div *ngIf="!vendaLegadoEmpresasCarregando && !vendaLegadoEmpresasErro && vendaLegadoEmpresas.length === 0" class="div-loading">
        Nenhuma empresa encontrada no Aerosys.
      </div>

      <div *ngIf="!vendaLegadoEmpresasCarregando && vendaLegadoEmpresas.length > 0" class="os-empresas-grid">
        <button *ngFor="let e of vendaLegadoEmpresas"
                type="button"
                class="os-empresa-card"
                [style.background]="corOsEmpresaClara(e.id)"
                [style.border-color]="corOsEmpresa(e.id)"
                (click)="selecionarVendaLegadoEmpresa(e)">
          <span class="os-empresa-dot" [style.background]="corOsEmpresa(e.id)"></span>
          <span class="os-empresa-info">
            <span class="os-empresa-nome">{{ e.nome || e.razao || ('Empresa ' + e.id) }}</span>
            <span class="os-empresa-cnpj" *ngIf="e.cnpj">{{ e.cnpj }}</span>
          </span>
        </button>
      </div>
    </div>

    <!-- Step 2: lista de Vendas da empresa selecionada -->
    <div *ngIf="vendaLegadoStep === 2" class="os-lista-bloco">
      <div class="os-filtros">
        <button type="button" class="os-voltar-btn" (click)="voltarVendaLegadoEmpresas()" [disabled]="vendaLegadoCarregando">
          ← Trocar empresa
        </button>
        <div class="os-filtro-campo os-filtro-busca">
          <label>Buscar (Cliente, Status, Nº Venda, Tipo)</label>
          <input type="text" class="dup-input" [(ngModel)]="vendaLegadoFiltroTexto" placeholder="Digite para filtrar...">
        </div>
        <div class="os-filtro-campo">
          <label>Data inicial</label>
          <input type="date" class="dup-input" [(ngModel)]="vendaLegadoStartDate" [disabled]="vendaLegadoCarregando">
        </div>
        <div class="os-filtro-campo">
          <label>Data final</label>
          <input type="date" class="dup-input" [(ngModel)]="vendaLegadoEndDate" [disabled]="vendaLegadoCarregando">
        </div>
        <button type="button" class="div-btn-confirmar"
                (click)="buscarVendasLegado()" [disabled]="vendaLegadoCarregando"><app-loading-indicator *ngIf="vendaLegadoCarregando" size="inline"></app-loading-indicator>
          {{ vendaLegadoCarregando ? 'Buscando...' : 'Buscar' }}
        </button>
      </div>

      <div *ngIf="vendaLegadoErro" class="div-alerta div-alerta-erro">{{ vendaLegadoErro }}</div>

      <div *ngIf="vendaLegadoCarregando" class="div-loading">
        <app-loading-indicator size="inline"></app-loading-indicator>
        Carregando Vendas...
      </div>

      <div *ngIf="!vendaLegadoCarregando && !vendaLegadoErro && vendaLegadoLista.length === 0" class="div-loading">
        Nenhuma Venda encontrada no período selecionado.
      </div>

      <div *ngIf="!vendaLegadoCarregando && vendaLegadoLista.length > 0 && vendaLegadoListaFiltrada.length === 0" class="div-loading">
        Nenhuma Venda encontrada para o filtro "{{ vendaLegadoFiltroTexto }}".
      </div>

      <div *ngIf="!vendaLegadoCarregando && vendaLegadoListaFiltrada.length > 0" class="os-tabela-wrap">
        <table class="div-tabela">
          <thead>
            <tr>
              <th class="div-th-num">Nº Venda</th>
              <th class="div-th-cd">Tipo</th>
              <th class="div-th-cd">Status</th>
              <th class="div-th-cd">Emissão</th>
              <th class="div-th-prod">Cliente</th>
              <th class="div-th-num div-th-valor">Total Faturado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let v of vendaLegadoListaFiltrada" class="os-linha-clicavel"
                [class.os-linha-desabilitada]="vendaLegadoDetalheCarregando"
                [class.os-linha-cancelada]="isOsCancelada(v.status)"
                [title]="isOsCancelada(v.status) ? 'Venda cancelada — não é possível gerar venda' : ''"
                (click)="!vendaLegadoDetalheCarregando && !isOsCancelada(v.status) && onSelecionarVendaLegado(v)">
              <td class="div-td-num">{{ v.numTitulo || v.id }}</td>
              <td class="div-td-cd">{{ v.tipo || '—' }}</td>
              <td class="div-td-cd"><span class="os-status-badge" [style.background]="corVendaStatus(v.status)" [style.color]="corVendaStatusTexto(v.status)">{{ v.status || '—' }}</span></td>
              <td class="div-td-cd">{{ v.dataEmissao ? (v.dataEmissao | date:'dd/MM/yyyy') : '—' }}</td>
              <td class="div-td-prod">{{ v.clienteNome || '—' }}</td>
              <td class="div-td-num div-td-valor">{{ v.totFaturado != null ? (v.totFaturado | currency:'BRL':'symbol':'1.2-2':'pt-BR') : '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>

</main>


<!-- ── Toast de aviso (item único, erros sem modal) ── -->
<div *ngIf="toastVisivel" class="toast-aviso" (click)="toastVisivel = false" title="Clique para fechar">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;">
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r=".5" fill="currentColor"/>
  </svg>
  <div style="flex: 1;">{{ toastMensagem }}</div>
</div>

<!-- ── Modal Desmembrar Venda (nível raiz, fora do content-shell) ── -->
<div class="div-overlay" *ngIf="modalDividirAberto" (click)="fecharModalDividir()">
  <div class="div-modal div-modal-qtd" (click)="$event.stopPropagation()">

    <!-- Cabeçalho -->
    <div class="div-header">
      <div class="div-icone">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="21" y1="12" x2="3" y2="12"/>
          <polyline points="9 18 3 12 9 6"/>
          <polyline points="15 6 21 12 15 18"/>
        </svg>
      </div>
      <div>
        <div class="div-titulo">Desmembrar Venda{{ dividirNunota ? ' #' + dividirNunota : '' }}</div>
        <div class="div-subtitulo">Informe a quantidade a desmembrar para cada item</div>
      </div>
      <button class="div-fechar" (click)="fecharModalDividir()" [disabled]="dividirCarregando || dividirItensCarregando">✕</button>
    </div>

    <!-- Mensagens -->
    <div *ngIf="dividirErro" class="div-alerta div-alerta-erro">{{ dividirErro }}</div>
    <div class="div-alerta div-alerta-aviso" style="font-size:12px;">
      Se a venda já está em Separação, os itens já separados/serial baixado são levados
      junto pro pedido novo ou mantidos no original conforme a divisão — mas a pilha
      física no chão precisa ser reconciliada manualmente com a nova tag/pedido.
    </div>

    <!-- Carregando -->
    <div *ngIf="dividirItensCarregando" class="div-loading">
      <app-loading-indicator size="inline"></app-loading-indicator>
      Carregando itens...
    </div>

    <!-- Tabela de itens com input de quantidade -->
    <div *ngIf="!dividirItensCarregando" class="div-tabela-wrap">
      <table class="div-tabela">
        <thead>
          <tr>
            <th class="div-th-pn">PN</th>
            <th class="div-th-cd">CD</th>
            <th class="div-th-prod">Descrição</th>
            <th class="div-th-num">Qtd. Total</th>
            <th class="div-th-num">Qtd. → Nova Venda</th>
            <th class="div-th-num">Restante</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dividirItens"
              [class.div-row-parcial]="item.qtdParaMover > 0 && item.qtdParaMover < item.qtdOriginal"
              [class.div-row-total]="item.qtdParaMover >= item.qtdOriginal && item.qtdParaMover > 0">
            <td class="div-td-pn">{{ item.refforn || '—' }}</td>
            <td class="div-td-cd">{{ item.condicao || '—' }}</td>
            <td class="div-td-prod">
              <span class="div-item-desc">{{ item.descricao }}</span>
              <span class="div-item-meta">Cód. {{ item.codprod }}</span>
            </td>
            <td class="div-td-num">{{ item.qtdOriginal }}</td>
            <td class="div-td-num">
              <input type="number" class="div-qtd-input"
                     [(ngModel)]="item.qtdParaMover"
                     min="0" [max]="item.qtdOriginal" step="1"
                     (input)="onDividirQtdInput($event, item)"
                     (ngModelChange)="clampDividirQtd(item)"
                     (keydown.enter)="navegarDividirQtd($event)"
                     (focus)="$any($event.target).select()">
            </td>
            <td class="div-td-num" [class.div-restante-zero]="item.qtdParaMover > 0 && item.qtdParaMover >= item.qtdOriginal">
              {{ item.qtdOriginal - item.qtdParaMover }}
              <span *ngIf="item.qtdParaMover > 0 && item.qtdParaMover >= item.qtdOriginal" class="div-aviso-zero" title="Item não ficará na origem">⚠</span>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Resumo -->
      <div class="div-resumo" *ngIf="dividirItensNova.length > 0 && !origemFicariaSemItens">
        Nova Venda receberá
        <strong>{{ dividirItensNova.length }} {{ dividirItensNova.length === 1 ? 'item' : 'itens' }}</strong>
        · <strong>{{ dividirTotalUnidadesNova }} un.</strong> no total
      </div>
      <div class="div-alerta div-alerta-erro" *ngIf="origemFicariaSemItens">
        Não é possível mover todos os itens — a venda original ficaria sem itens.
      </div>
    </div>

    <!-- Sub-diálogo de aviso (quantidade total) -->
    <div *ngIf="dividirAvisoAberto" class="div-aviso-overlay" (click)="$event.stopPropagation()">
      <div class="div-aviso-box div-aviso-box--preview">

        <!-- Título -->
        <div class="div-aviso-titulo div-aviso-titulo--preview">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="6" cy="6" r="3"/><circle cx="18" cy="18" r="3"/>
            <path d="M18 9a9 9 0 0 0-9 9"/><line x1="6" y1="9" x2="6" y2="21"/>
            <line x1="9" y1="6" x2="21" y2="6"/>
          </svg>
          Confirmar Desmembramento
        </div>

        <!-- Preview lado a lado -->
        <div class="div-preview-split">

          <!-- Origem -->
          <div class="div-preview-col div-preview-col--origem">
            <div class="div-preview-col-header">
              <span class="div-preview-col-tag div-preview-col-tag--origem">Origem</span>
              <span class="div-preview-col-nota">#{{ dividirNunota }}</span>
            </div>
            <div class="div-preview-col-sub">Permanece na venda original</div>
            <div class="div-preview-lista">
              <div *ngFor="let i of dividirPreviewOrigem" class="div-preview-item">
                <span class="div-preview-desc">{{ i.descricao }}</span>
                <span class="div-preview-qty div-preview-qty--origem">{{ i.qtd }} un.</span>
              </div>
              <div *ngIf="dividirPreviewOrigem.length === 0" class="div-preview-vazio">
                ⚠ Nenhum item restará na origem
              </div>
            </div>
          </div>

          <!-- Seta -->
          <div class="div-preview-seta">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </div>

          <!-- Destino -->
          <div class="div-preview-col div-preview-col--destino">
            <div class="div-preview-col-header">
              <span class="div-preview-col-tag div-preview-col-tag--destino">Nova Venda</span>
            </div>
            <div class="div-preview-col-sub">Receberá estes itens</div>
            <div class="div-preview-lista">
              <div *ngFor="let i of dividirPreviewDestino" class="div-preview-item">
                <span class="div-preview-desc">{{ i.descricao }}</span>
                <span class="div-preview-qty div-preview-qty--destino">{{ i.qtd }} un.</span>
              </div>
            </div>
          </div>

        </div><!-- /div-preview-split -->

        <!-- Aviso itens totalmente transferidos -->
        <div *ngIf="dividirAvisoItensTotal.length > 0" class="div-aviso-warn">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="#d97706" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <span>
            <strong>{{ dividirAvisoItensTotal.length === 1 ? 'Um item será' : dividirAvisoItensTotal.length + ' itens serão' }}</strong>
            completamente transferidos e não permanecerão na venda original:
            {{ dividirAvisoItensNomes }}.
          </span>
        </div>

        <!-- Ações -->
        <div class="div-aviso-acoes">
          <button type="button" class="dup-btn-cancelar" (click)="dividirAvisoAberto = false">Voltar e Ajustar</button>
          <button type="button" class="div-btn-aviso-ok" (click)="confirmarDividirComAviso()">Confirmar Desmembramento</button>
        </div>

      </div>
    </div>

    <!-- Ações -->
    <div class="div-acoes">
      <button type="button" class="dup-btn-cancelar"
              (click)="fecharModalDividir()"
              [disabled]="dividirCarregando || dividirItensCarregando">
        Cancelar
      </button>
      <button type="button" class="div-btn-confirmar"
              (click)="confirmarDividir()"
              [disabled]="dividirCarregando || dividirItensCarregando || dividirItensNova.length === 0 || origemFicariaSemItens">
        <app-loading-indicator *ngIf="dividirCarregando" size="inline"></app-loading-indicator>
        {{ dividirCarregando ? 'Desmembrando...' : 'Confirmar Desmembramento' }}
      </button>
    </div>

  </div>
</div>

<!-- ── Modal Dados do Transporte ── -->
<div class="dup-overlay" *ngIf="modalTransporteAberto" (click)="fecharModalTransporte()">
  <div class="trp-modal" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="trp-header">
      <div class="trp-header-icone">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="3" width="15" height="13" rx="1"/>
          <path d="M16 8h4l3 5v3h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
      </div>
      <div>
        <div class="trp-titulo">Dados do Transporte</div>
        <div class="trp-subtitulo" *ngIf="transporteNunota">
          Venda <strong>#{{ transporteNunota }}</strong>
          <span *ngIf="transporteNomeCliente"> — {{ transporteNomeCliente }}</span>
        </div>
      </div>
      <button class="dup-btn-fechar" (click)="fecharModalTransporte()" [disabled]="transporteSalvando">✕</button>
    </div>

    <!-- Carregando -->
    <div class="trp-carregando" *ngIf="transporteCarregando">
      <app-loading-indicator size="inline"></app-loading-indicator> Carregando dados...
    </div>

    <ng-container *ngIf="!transporteCarregando">

      <!-- PESSOA DE ENTREGA — faixa full-width acima das colunas -->
      <div class="trp-pessoa-faixa">
        <div class="trp-secao-titulo" style="margin-bottom:4px">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
          </svg>
          PESSOA DE ENTREGA
        </div>
        <div class="trp-titulos-linha">
          <span *ngFor="let t of titulosPessoaEntModal" class="trp-titulo-extra" [style.left.px]="t.left">{{ t.label }}</span>
        </div>
        <div class="trp-end-input-wrap">
          <svg class="trp-end-input-ico" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input class="trp-end-input-field trp-pessoa-display-input" disabled
            [value]="transportePessoaEntregaDisplay || '— Não informado —'">
        </div>
      </div>

      <!-- Layout duas colunas: endereço (esquerda) + transporte (direita) -->
      <div class="trp-duas-colunas">

        <!-- COLUNA ESQUERDA: Endereço de entrega -->
        <div class="trp-coluna-end">

          <!-- Endereço de Entrega -->
          <div class="trp-secao-titulo" style="margin-bottom:10px">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            ENDEREÇO DE ENTREGA
            <span class="trp-badge-readonly">Somente leitura</span>
          </div>

          <div class="trp-end-form">
            <!-- Logradouro + Número -->
            <div class="trp-end-row">
              <div class="trp-end-campo">
                <label class="trp-end-lbl">Logradouro</label>
                <input class="trp-end-input-field" disabled [value]="transporteEndLogradouro || ''">
              </div>
              <div class="trp-end-campo trp-end-numero">
                <label class="trp-end-lbl">Número</label>
                <input class="trp-end-input-field" disabled [value]="transporteEndNumero || ''">
              </div>
            </div>
            <!-- Complemento -->
            <div class="trp-end-campo">
              <label class="trp-end-lbl">Complemento</label>
              <input class="trp-end-input-field" disabled [value]="transporteEndComplemento || ''">
            </div>
            <!-- Bairro + CEP -->
            <div class="trp-end-row">
              <div class="trp-end-campo">
                <label class="trp-end-lbl">Bairro</label>
                <input class="trp-end-input-field" disabled [value]="transporteEndBairro || ''">
              </div>
              <div class="trp-end-campo trp-end-cep">
                <label class="trp-end-lbl">CEP</label>
                <input class="trp-end-input-field" disabled [value]="transporteEndCep || ''">
              </div>
            </div>
            <!-- Cidade + UF -->
            <div class="trp-end-row">
              <div class="trp-end-campo">
                <label class="trp-end-lbl">Cidade</label>
                <input class="trp-end-input-field" disabled [value]="transporteEndCidade || ''">
              </div>
              <div class="trp-end-campo trp-end-uf">
                <label class="trp-end-lbl">UF</label>
                <input class="trp-end-input-field" disabled [value]="transporteEndUf || ''">
              </div>
            </div>
          </div>

        </div><!-- /coluna endereço -->

        <!-- COLUNA DIREITA: Dados do transporte (editáveis) -->
        <div class="trp-coluna-trp">

      <!-- Dados do transporte (editáveis) -->
      <div class="trp-corpo">

        <div class="trp-secao-titulo" style="margin-bottom:12px">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="3" width="15" height="13" rx="1"/>
            <path d="M16 8h4l3 5v3h-7V8z"/>
            <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
          </svg>
          DADOS DO TRANSPORTE
        </div>

        <!-- Transportadora (autocomplete) -->
        <div class="dup-campo" style="margin-bottom:14px; position:relative">
          <div class="trp-titulos-linha">
            <span class="dup-label" style="font-size:11px;font-weight:700;line-height:14px;margin:0">TRANSPORTADORA</span>
            <span *ngFor="let t of titulosTranspModal" class="trp-titulo-extra" [style.left.px]="t.left">{{ t.label }}</span>
          </div>
          <div class="trp-input-icon-wrap">
            <button type="button" class="trp-cliente-icon-btn" (click)="onTransporteTranspFocus()" title="Buscar Transportadora" [disabled]="transporteSalvando">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </button>
            <input
              type="text"
              class="dup-input trp-busca-input"
              [style.padding-left.px]="trpBuscaInputStartX - 1.5"
              placeholder="Digite o nome ou CNPJ/CPF..."
              [(ngModel)]="transporteTranspBusca"
              (input)="onTransporteTranspInput()"
              (focus)="onTransporteTranspFocus()"
              (blur)="onTransporteTranspBlur()"
              autocomplete="off"
              [disabled]="transporteSalvando"
            >
            <button *ngIf="transporteTranspSelecionada" class="trp-input-clear-btn" type="button" (click)="removerTransporteTransp()">✕</button>
          </div>
          <!-- Dropdown de sugestões -->
          <div class="trp-cliente-dropdown" *ngIf="transporteMostrarDropdownTransp">
            <div *ngIf="transporteTranspCarregando" class="trp-dropdown-loading">
              <app-loading-indicator size="inline"></app-loading-indicator> Buscando...
            </div>
            <div *ngIf="!transporteTranspCarregando && transporteTranspSugestoes.length === 0" class="trp-dropdown-vazio">
              Nenhuma transportadora encontrada
            </div>
            <button *ngFor="let s of transporteTranspSugestoes" type="button"
              class="trp-dropdown-item" (mousedown)="selecionarTransporteTransp(s)">
              <div class="trp-item-nome">{{ s.nomeparc }}</div>
              <div class="trp-item-detalhes">
                <span *ngIf="s.docparc">{{ fmtDocumento(s.docparc) }}</span>
                <span *ngIf="s.inscEstadual">&nbsp;|&nbsp;{{ fmtIE(s.inscEstadual) }}</span>
              </div>
            </button>
          </div>
        </div>

        <!-- Linha: Qtd. Volumes + Peso Bruto + Tipo Frete -->
        <div class="trp-linha-3">
          <div class="dup-campo">
            <label class="dup-label">QTD. VOLUMES</label>
            <input type="number" class="dup-input" min="0" step="1"
                   [(ngModel)]="transporteQtdVol"
                   [disabled]="transporteSalvando">
          </div>
          <div class="dup-campo">
            <label class="dup-label">PESO BRUTO (KG)</label>
            <input type="number" class="dup-input" min="0" step="0.001"
                   [(ngModel)]="transportePesoBruto"
                   [disabled]="transporteSalvando">
          </div>
          <div class="dup-campo">
            <label class="dup-label">TIPO DO FRETE</label>
            <select class="dup-input" [(ngModel)]="transporteTipFrete" [disabled]="transporteSalvando">
              <option value="">— Selecione —</option>
              <option *ngFor="let o of transporteTipFreteOpcoes" [value]="o.valor"
                  [disabled]="transporteVlrFreteBloqueado && o.label.toUpperCase().includes('INCLUS')">{{ o.label }}</option>
            </select>
          </div>
        </div>

        <!-- Linha: CIF/FOB + Forma de Envio -->
        <div class="trp-linha-2" style="margin-top:12px">
          <div class="dup-campo">
            <label class="dup-label">CIF/FOB</label>
            <select class="dup-input" [(ngModel)]="transporteCifFob" (ngModelChange)="onTransporteCifFobChange()" [disabled]="transporteSalvando">
              <option value="">— Selecione —</option>
              <option *ngFor="let o of transporteCifFobOpcoes" [value]="o.valor">{{ o.label }}</option>
            </select>
          </div>
          <div class="dup-campo">
            <label class="dup-label">FORMA DE ENVIO</label>
            <select class="dup-input" [(ngModel)]="transporteFormaEnvio" [disabled]="transporteSalvando">
              <option value="">— Selecione —</option>
              <option *ngFor="let o of transporteFormaEnvioOpcoes" [value]="o.valor">{{ o.label }}</option>
            </select>
          </div>
        </div>

        <!-- Linha: VLR. FRETE -->
        <div class="trp-linha-vlr" style="margin-top:12px">
          <div class="dup-campo">
            <label class="dup-label">VLR. FRETE</label>
            <input type="text" appMoneyMask class="dup-input trp-vlr-frete-input"
                   [(ngModel)]="trpVlrFrete"
                   [disabled]="transporteSalvando || transporteVlrFreteBloqueado"
                   [title]="transporteVlrFreteBloqueado ? 'Modalidade de frete selecionada não permite cobrar frete nesta nota' : ''"
                   placeholder="0,00">
          </div>
          <div></div>
        </div>

        <!-- Observação Frete (TGFCAB.AD_FRETEOBS) — somente leitura no gateway -->
        <div class="dup-campo" style="margin-top:12px" *ngIf="trpAdFreteObs">
          <label class="dup-label">Observação Frete</label>
          <textarea class="dup-input trp-freteobs-textarea" readonly rows="3">{{ trpAdFreteObs }}</textarea>
        </div>

      </div><!-- /trp-corpo -->
        </div><!-- /trp-coluna-trp -->
      </div><!-- /trp-duas-colunas -->

      <!-- Erro -->
      <div class="div-alerta div-alerta-erro" *ngIf="transporteErro" style="margin:0 20px 4px">
        {{ transporteErro }}
      </div>
      <div class="div-alerta div-alerta-erro" *ngIf="transporteImprimirErro" style="margin:0 20px 4px">
        {{ transporteImprimirErro }}
      </div>

      <!-- Ações -->
      <div class="div-acoes trp-acoes-centro">
        <button type="button" class="trp-btn-imprimir"
                (click)="imprimirDadosTransporte()"
                [disabled]="imprimindoTransporte || transporteSalvando">
          <app-loading-indicator *ngIf="imprimindoTransporte" size="inline"></app-loading-indicator>
          {{ imprimindoTransporte ? 'Imprimindo...' : 'Etiqueta' }}
        </button>
        <button type="button" class="div-btn-confirmar trp-btn-salvar"
                (click)="confirmarTransporte()"
                [disabled]="transporteSalvando">
          <app-loading-indicator *ngIf="transporteSalvando" size="inline"></app-loading-indicator>
          {{ transporteSalvando ? 'Salvando...' : 'Salvar Transporte' }}
        </button>
      </div>

    </ng-container>
  </div>
</div>

<!-- ── Modal: escolher qual etiqueta imprimir (só aparece quando há mais de
     uma etiqueta liberada pra essa tela em Parâmetros do Sistema) ── -->
<div class="dup-overlay" *ngIf="modalEscolherEtiquetaAberto" (click)="fecharEscolherEtiqueta()">
  <div class="trp-modal-escolher-etiqueta" (click)="$event.stopPropagation()">
    <div class="trp-header">
      <div>
        <div class="trp-titulo">Escolha a etiqueta</div>
        <div class="trp-subtitulo">Mais de uma etiqueta está liberada para esta tela</div>
      </div>
      <button class="dup-btn-fechar" (click)="fecharEscolherEtiqueta()" [disabled]="imprimindoTransporte">✕</button>
    </div>
    <div class="trp-lista-etiquetas">
      <button type="button" class="trp-item-etiqueta"
        *ngFor="let et of etiquetasTransporteDisponiveis"
        [disabled]="imprimindoTransporte"
        (click)="escolherEtiquetaTransporte(et.codconfig)">
        <app-loading-indicator *ngIf="imprimindoTransporte" size="inline"></app-loading-indicator>
        {{ et.nome }}
      </button>
    </div>
  </div>
</div>

<!-- ── Modal Anexos da Venda (GPL_ANEXO_VENDA — nível raiz, fora do content-shell) ── -->
<div class="dup-overlay" *ngIf="anexosModalAberto" (click)="fecharModalAnexos()">
  <div class="anx-modal" (click)="$event.stopPropagation()">

    <div class="trp-header">
      <div class="trp-header-icone">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
        </svg>
      </div>
      <div>
        <div class="trp-titulo">Anexos</div>
        <div class="trp-subtitulo" *ngIf="anexosNunota">Venda <strong>#{{ anexosNunota }}</strong></div>
      </div>
      <button class="dup-btn-fechar" (click)="fecharModalAnexos()">✕</button>
    </div>

    <div class="anx-body">
      <label class="anx-btn-upload" [class.anx-btn-upload-desabilitado]="anexoEnviando">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
        </svg>
        {{ anexoEnviando ? 'Enviando...' : 'Anexar Arquivo' }}
        <input type="file" multiple style="display:none" [disabled]="anexoEnviando" (change)="onSelecionarArquivosAnexo($event)">
      </label>

      <div class="anx-carregando" *ngIf="anexosCarregando">
        <app-loading-indicator size="inline"></app-loading-indicator> Carregando anexos...
      </div>

      <div class="anx-vazio" *ngIf="!anexosCarregando && anexosLista.length === 0">
        Nenhum arquivo anexado a esta venda ainda.
      </div>

      <div class="anx-lista" *ngIf="!anexosCarregando && anexosLista.length > 0">
        <div class="anx-item" *ngFor="let anexo of anexosLista">
          <div class="anx-item-info">
            <div class="anx-item-nome" [title]="anexo.nomeArquivo">{{ anexo.nomeArquivo }}</div>
            <div class="anx-item-meta">
              {{ formatarTamanhoAnexo(anexo.tamanho) }} · {{ anexo.nomeUsu }} · {{ anexo.dtanexo | date:'dd/MM/yyyy HH:mm' }}
            </div>
          </div>
          <div class="anx-item-acoes">
            <button class="anx-btn-icone anx-btn-icone-visualizar" title="Visualizar" (click)="visualizarAnexoVenda(anexo)">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </button>
            <button class="anx-btn-icone anx-btn-icone-baixar" title="Baixar" (click)="baixarAnexoVenda(anexo)">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            </button>
            <button class="anx-btn-icone anx-btn-icone-excluir" title="Excluir" (click)="excluirAnexoVenda(anexo)">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ── Modal Pré-visualização de Anexo (imagem/PDF) ── -->
<div class="dup-overlay anx-preview-overlay" *ngIf="previewModalAberto" (click)="fecharPreviewAnexo(); $event.stopPropagation()">
  <div class="anx-preview-modal" (click)="$event.stopPropagation()">
    <div class="anx-preview-header">
      <span class="anx-preview-nome">{{ previewNome }}</span>
      <button class="dup-btn-fechar" (click)="fecharPreviewAnexo(); $event.stopPropagation()">✕</button>
    </div>
    <div class="anx-preview-body">
      <img *ngIf="previewTipo === 'imagem' && previewUrl" [src]="previewUrl" [alt]="previewNome" class="anx-preview-img">
      <iframe *ngIf="previewTipo === 'pdf' && previewUrl" [src]="previewUrl" class="anx-preview-pdf"></iframe>
    </div>
  </div>
</div>

<!-- ── Modal Fluxo de Desmembramento da Venda (nível raiz, fora do content-shell) ── -->
<div class="dup-overlay" *ngIf="modalFluxoAberto" (click)="fecharModalFluxo()">
  <div class="fluxo-modal" (click)="$event.stopPropagation()">

    <div class="fluxo-header">
      <div class="fluxo-icone">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/>
          <path d="M6 9v6"/><path d="M9 6h7a2 2 0 0 1 2 2v7"/>
        </svg>
      </div>
      <div>
        <div class="fluxo-titulo">Fluxo de Desmembramento da Venda</div>
        <div class="fluxo-subtitulo">Cadeia de desmembramentos da venda <strong>#{{ fluxoNunota }}</strong></div>
      </div>
      <button class="btn-filtrar-fluxo" type="button"
        *ngIf="!fluxoCarregando && fluxoNos.length > 0"
        (click)="filtrarVendasDoFluxo()"
        title="Filtrar a lista de pedidos para mostrar apenas os pedidos deste fluxo">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
        </svg>
        Filtrar vendas do fluxo
      </button>
      <button class="div-fechar" (click)="fecharModalFluxo()" [disabled]="fluxoCarregando">✕</button>
    </div>

    <!-- Loading -->
    <div *ngIf="fluxoCarregando" class="div-loading">
      <app-loading-indicator size="inline"></app-loading-indicator>
      Carregando fluxo...
    </div>

    <!-- Erro ou sem fluxo -->
    <div *ngIf="!fluxoCarregando && fluxoErro" class="div-alerta div-alerta-erro">{{ fluxoErro }}</div>

    <!-- Cadeia em árvore -->
    <div *ngIf="!fluxoCarregando && !fluxoErro && fluxoNos.length > 0" class="fluxo-cadeia-wrap">

      <ng-template #fluxoModalNode let-no="no">
        <div class="flx-wrap">
          <div class="flx-left">
            <div class="fluxo-no"
                 [class.fluxo-no--selecionado]="no.ehSelecionada"
                 [class.fluxo-no--raiz]="no.ehRaiz && !no.ehSelecionada"
                 [class.fluxo-no--clicavel]="!no.ehSelecionada"
                 (click)="!no.ehSelecionada && fluxoNavegar(no.nunota, no.codemp)">
              <div class="fluxo-no-header">
                <span *ngIf="no.ehRaiz" class="fluxo-badge fluxo-badge-raiz">Origem</span>
                <span *ngIf="no.ehSelecionada" class="fluxo-badge fluxo-badge-sel">Esta venda</span>
                <span *ngIf="!no.ehRaiz && !no.ehSelecionada" class="fluxo-badge fluxo-badge-nav">Abrir</span>
              </div>
              <div class="fluxo-no-num">#{{ no.nunota }}</div>
              <div class="fluxo-no-data">{{ no.dtmov || '—' }}</div>
              <span class="fluxo-no-status" [class]="fluxoStatusClass(no.status)">
                {{ fluxoStatusLabel(no.status) }}
              </span>
              <!-- Chip de empresa: aparece sempre para identificar filial -->
              <span *ngIf="no.codemp"
                    class="fluxo-badge-emp"
                    [style.background]="empresaState.corClaraPorCodEmp(no.codemp)"
                    [style.border-color]="empresaState.corPorCodEmp(no.codemp)">
                Filial {{ no.codemp }}
              </span>
            </div>
          </div>
          <div class="flx-right" *ngIf="no.filhos?.length > 0">
            <div class="flx-row"
                 *ngFor="let filho of no.filhos; let first = first; let last = last"
                 [class.is-first]="first" [class.is-last]="last">
              <div class="flx-hz" [class.is-primary]="first" [class.is-secondary]="!first"></div>
              <ng-container *ngTemplateOutlet="fluxoModalNode; context: { no: filho }"></ng-container>
            </div>
          </div>
        </div>
      </ng-template>

      <div class="flx-root">
        <ng-container *ngFor="let raiz of fluxoRaizes">
          <ng-container *ngTemplateOutlet="fluxoModalNode; context: { no: raiz }"></ng-container>
        </ng-container>
      </div>

    </div>

  </div>
</div>

<!-- ── Modal Transferir Venda (nível raiz, fora do content-shell) ── -->
<div class="dup-overlay" *ngIf="modalTransferirAberto" (click)="fecharModalTransferir()">
  <div class="dup-modal" (click)="$event.stopPropagation()">

    <div class="trf-icone">
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14"/><path d="M12 5l7 7-7 7"/>
      </svg>
    </div>

    <div class="dup-titulo">Transferir Venda</div>
    <div class="dup-subtitulo">
      Selecione a empresa de destino para transferir o pedido <strong>#{{ transferirNunota }}</strong>.<br>
      <small style="color:#9ca3af">A venda original será cancelada após a transferência.</small>
    </div>

    <div *ngIf="transferirErro" class="dup-erro">{{ transferirErro }}</div>

    <div class="dup-empresas-wrap">
      <label class="dup-label">Empresa de destino</label>
      <div class="dup-empresas-grid">
        <button *ngFor="let e of transferirEmpresasOpcoes"
                type="button"
                class="dup-empresa-card"
                [class.dup-empresa-card--ativa]="empTransferirSelecionada === e.codEmp"
                [style.background]="empresaState.corClaraPorCodEmp(e.codEmp, 0.80)"
                [style.border-color]="empTransferirSelecionada === e.codEmp ? empresaState.corPorCodEmp(e.codEmp) : 'transparent'"
                (click)="empTransferirSelecionada = e.codEmp"
                [disabled]="transferirCarregando || e.codEmp === transferirCodEmpOrigem">
          <span class="dup-emp-dot" [style.background]="empresaState.corPorCodEmp(e.codEmp)"></span>
          <span class="dup-emp-cod">{{ e.codEmp }}</span>
          <span class="dup-emp-nome">{{ e.nomeFant || e.razaoAbrev }}</span>
          <span *ngIf="e.codEmp === transferirCodEmpOrigem" class="trf-empresa-desabilitada">atual</span>
        </button>
      </div>
    </div>

    <div class="dup-acoes">
      <button type="button" class="dup-btn-cancelar"
              (click)="fecharModalTransferir()"
              [disabled]="transferirCarregando">
        Cancelar
      </button>
      <button type="button" class="dup-btn-confirmar"
              style="background:#0d9488"
              (click)="confirmarTransferir()"
              [disabled]="transferirCarregando || !empTransferirSelecionada">
        <app-loading-indicator *ngIf="transferirCarregando" size="inline"></app-loading-indicator>
        {{ transferirCarregando ? 'Transferindo...' : 'Transferir' }}
      </button>
    </div>

  </div>
</div>

<!-- ── Consulta Global de Peças (F7 — disponível em qualquer tela) ── -->
<div class="cq-overlay" *ngIf="consultaPecasAberta" (click)="fecharConsultaPecas()">
  <div class="cq-modal" (click)="$event.stopPropagation()">

    <div class="cq-header">
      <span>Consulta de Peças</span>
      <span class="cq-header-hint">Somente leitura · F7 para fechar</span>
      <button type="button" class="cq-close-btn" (click)="fecharConsultaPecas()">✕</button>
    </div>

    <div class="cq-body">

      <div class="cq-top-area">
        <!-- Campo de busca -->
        <div class="cq-campo">
          <svg class="cq-icone" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input type="text" class="consulta-pecas-input"
                 [(ngModel)]="consultaPecasTermo"
                 (ngModelChange)="onConsultaPecasInput()"
                 placeholder="Digite o PN (ex: 010-11654) ou descrição (ex: ACUMULADOR GPS)..."
                 autocomplete="off">
          <app-loading-indicator *ngIf="consultaPecasCarregando" size="inline"></app-loading-indicator>
        </div>
        <div class="cq-dica">Busca por PN ou descrição · Mínimo 2 caracteres</div>
      </div>

      <div class="cq-lista-area">
        <!-- Sem resultado -->
        <div *ngIf="consultaPecasSemResultado && !consultaPecasCarregando" class="cq-vazio">
          Nenhuma peça encontrada.
        </div>

        <!-- Tabela unificada: resultados + alternativos sob o mesmo cabeçalho -->
        <div *ngIf="consultaPecasResultados.length > 0" class="cq-lista">
          <table class="cq-tabela">
            <thead>
              <tr>
                <th class="th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'pn'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('pn')" (click)="toggleFiltroConsulta('pn', $event)" [title]="temFiltroConsulta('pn') ? ('Filtro: ' + filtrosConsulta['pn']) : 'Clique para filtrar'">PN</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='pn'" (click)="ordenarConsultaPecas('pn')">{{ consultaPecasOrdenarCampo==='pn' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('pn')" class="th-filtro-limpar" (click)="limparFiltroConsulta('pn', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'pn'" id="filtro-consulta-pn" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['pn']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('pn'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'cd'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('cd')" (click)="toggleFiltroConsulta('cd', $event)" [title]="temFiltroConsulta('cd') ? ('Filtro: ' + filtrosConsulta['cd']) : 'Clique para filtrar'">CD</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='cd'" (click)="ordenarConsultaPecas('cd')">{{ consultaPecasOrdenarCampo==='cd' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('cd')" class="th-filtro-limpar" (click)="limparFiltroConsulta('cd', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'cd'" id="filtro-consulta-cd" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['cd']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('cd'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'descricao'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('descricao')" (click)="toggleFiltroConsulta('descricao', $event)" [title]="temFiltroConsulta('descricao') ? ('Filtro: ' + filtrosConsulta['descricao']) : 'Clique para filtrar'">Descrição</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='descricao'" (click)="ordenarConsultaPecas('descricao')">{{ consultaPecasOrdenarCampo==='descricao' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('descricao')" class="th-filtro-limpar" (click)="limparFiltroConsulta('descricao', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'descricao'" id="filtro-consulta-descricao" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['descricao']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('descricao'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'un'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('un')" (click)="toggleFiltroConsulta('un', $event)" [title]="temFiltroConsulta('un') ? ('Filtro: ' + filtrosConsulta['un']) : 'Clique para filtrar'">UN</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='un'" (click)="ordenarConsultaPecas('un')">{{ consultaPecasOrdenarCampo==='un' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('un')" class="th-filtro-limpar" (click)="limparFiltroConsulta('un', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'un'" id="filtro-consulta-un" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['un']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('un'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="text-right th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'estoque'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('estoque')" (click)="toggleFiltroConsulta('estoque', $event)" [title]="temFiltroConsulta('estoque') ? ('Filtro: ' + filtrosConsulta['estoque']) : 'Clique para filtrar'">Estoque</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='estoque'" (click)="ordenarConsultaPecas('estoque')">{{ consultaPecasOrdenarCampo==='estoque' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('estoque')" class="th-filtro-limpar" (click)="limparFiltroConsulta('estoque', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'estoque'" id="filtro-consulta-estoque" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['estoque']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('estoque'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <!-- Valor Moeda / Valor R$ (sem IPI) ocultas a pedido do usuário — mantidas
                     comentadas (não removidas) caso precisem voltar. Ver também os <td>
                     correspondentes nas linhas do item principal e dos alternativos abaixo,
                     e os colspan="14" ajustados para 14 (mesmo padrão da Busca de Peças F3). -->
                <!-- <th class="text-right">Valor Moeda</th> -->
                <!-- <th class="text-right">Valor R$</th> -->
                <th class="text-right th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'valorMoedaIpi'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('valorMoedaIpi')" (click)="toggleFiltroConsulta('valorMoedaIpi', $event)" [title]="temFiltroConsulta('valorMoedaIpi') ? ('Filtro: ' + filtrosConsulta['valorMoedaIpi']) : 'Clique para filtrar'">VALOR U$ + IPI</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='valorMoedaIpi'" (click)="ordenarConsultaPecas('valorMoedaIpi')">{{ consultaPecasOrdenarCampo==='valorMoedaIpi' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('valorMoedaIpi')" class="th-filtro-limpar" (click)="limparFiltroConsulta('valorMoedaIpi', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'valorMoedaIpi'" id="filtro-consulta-valorMoedaIpi" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['valorMoedaIpi']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('valorMoedaIpi'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="text-right th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'valorReaisIpi'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('valorReaisIpi')" (click)="toggleFiltroConsulta('valorReaisIpi', $event)" [title]="temFiltroConsulta('valorReaisIpi') ? ('Filtro: ' + filtrosConsulta['valorReaisIpi']) : 'Clique para filtrar'">Valor R$ + IPI</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='valorReaisIpi'" (click)="ordenarConsultaPecas('valorReaisIpi')">{{ consultaPecasOrdenarCampo==='valorReaisIpi' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('valorReaisIpi')" class="th-filtro-limpar" (click)="limparFiltroConsulta('valorReaisIpi', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'valorReaisIpi'" id="filtro-consulta-valorReaisIpi" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['valorReaisIpi']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('valorReaisIpi'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="text-right th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'vlrIpi'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('vlrIpi')" (click)="toggleFiltroConsulta('vlrIpi', $event)" [title]="temFiltroConsulta('vlrIpi') ? ('Filtro: ' + filtrosConsulta['vlrIpi']) : 'Clique para filtrar'">VLR IPI</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='vlrIpi'" (click)="ordenarConsultaPecas('vlrIpi')">{{ consultaPecasOrdenarCampo==='vlrIpi' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('vlrIpi')" class="th-filtro-limpar" (click)="limparFiltroConsulta('vlrIpi', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'vlrIpi'" id="filtro-consulta-vlrIpi" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['vlrIpi']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('vlrIpi'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'fabricante'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('fabricante')" (click)="toggleFiltroConsulta('fabricante', $event)" [title]="temFiltroConsulta('fabricante') ? ('Filtro: ' + filtrosConsulta['fabricante']) : 'Clique para filtrar'">Fabricante</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='fabricante'" (click)="ordenarConsultaPecas('fabricante')">{{ consultaPecasOrdenarCampo==='fabricante' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('fabricante')" class="th-filtro-limpar" (click)="limparFiltroConsulta('fabricante', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'fabricante'" id="filtro-consulta-fabricante" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['fabricante']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('fabricante'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'origem'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('origem')" (click)="toggleFiltroConsulta('origem', $event)" [title]="temFiltroConsulta('origem') ? ('Filtro: ' + filtrosConsulta['origem']) : 'Clique para filtrar'">Origem</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='origem'" (click)="ordenarConsultaPecas('origem')">{{ consultaPecasOrdenarCampo==='origem' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('origem')" class="th-filtro-limpar" (click)="limparFiltroConsulta('origem', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'origem'" id="filtro-consulta-origem" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['origem']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('origem'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="text-right th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'dataUltAtual'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('dataUltAtual')" (click)="toggleFiltroConsulta('dataUltAtual', $event)" [title]="temFiltroConsulta('dataUltAtual') ? ('Filtro: ' + filtrosConsulta['dataUltAtual']) : 'Clique para filtrar'">Data Ult. Atual. Preço</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='dataUltAtual'" (click)="ordenarConsultaPecas('dataUltAtual')">{{ consultaPecasOrdenarCampo==='dataUltAtual' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('dataUltAtual')" class="th-filtro-limpar" (click)="limparFiltroConsulta('dataUltAtual', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'dataUltAtual'" id="filtro-consulta-dataUltAtual" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['dataUltAtual']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('dataUltAtual'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="text-right th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'limiteDias'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('limiteDias')" (click)="toggleFiltroConsulta('limiteDias', $event)" [title]="temFiltroConsulta('limiteDias') ? ('Filtro: ' + filtrosConsulta['limiteDias']) : 'Clique para filtrar'">Limite p/ Atual. (Dias)</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='limiteDias'" (click)="ordenarConsultaPecas('limiteDias')">{{ consultaPecasOrdenarCampo==='limiteDias' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('limiteDias')" class="th-filtro-limpar" (click)="limparFiltroConsulta('limiteDias', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'limiteDias'" id="filtro-consulta-limiteDias" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['limiteDias']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('limiteDias'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'alternativo'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('alternativo')" (click)="toggleFiltroConsulta('alternativo', $event)" [title]="temFiltroConsulta('alternativo') ? ('Filtro: ' + filtrosConsulta['alternativo']) : 'Clique para filtrar'">Alternativo</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='alternativo'" (click)="ordenarConsultaPecas('alternativo')">{{ consultaPecasOrdenarCampo==='alternativo' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('alternativo')" class="th-filtro-limpar" (click)="limparFiltroConsulta('alternativo', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'alternativo'" id="filtro-consulta-alternativo" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['alternativo']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('alternativo'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
                <th class="text-right th-ordenavel">
                  <ng-container *ngIf="colunaFiltroConsultaAberta !== 'codigo'"><span class="th-label" [class.th-label-filtrado]="temFiltroConsulta('codigo')" (click)="toggleFiltroConsulta('codigo', $event)" [title]="temFiltroConsulta('codigo') ? ('Filtro: ' + filtrosConsulta['codigo']) : 'Clique para filtrar'">Código</span><span class="th-seta" [class.th-seta-ativa]="consultaPecasOrdenarCampo==='codigo'" (click)="ordenarConsultaPecas('codigo')">{{ consultaPecasOrdenarCampo==='codigo' ? (consultaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroConsulta('codigo')" class="th-filtro-limpar" (click)="limparFiltroConsulta('codigo', $event)" title="Limpar filtro">✕</span></ng-container>
                  <input *ngIf="colunaFiltroConsultaAberta === 'codigo'" id="filtro-consulta-codigo" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosConsulta['codigo']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroConsulta()" (keydown.enter)="fecharFiltroConsulta()" (keydown.escape)="limparFiltroConsulta('codigo'); fecharFiltroConsulta()" placeholder="Filtrar...">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="consultaPecasResultadosExibidos.length === 0">
                <td colspan="14" class="cq-vazio">Nenhum resultado para os filtros de coluna aplicados.</td>
              </tr>
              <!-- Resultados principais -->
              <ng-container *ngFor="let p of consultaPecasResultadosExibidos">
                <tr class="cq-linha"
                    [class.cq-linha-sel]="consultaPecasProdutoSelecionado === p"
                    [class.cq-sem-preco]="p.vlrVenda == null || p.vlrVenda <= 0"
                    [class.cq-preco-desatualizado]="p.precoDesatualizado && p.vlrVenda > 0"
                    (click)="selecionarProdutoConsulta(p)">
                  <td class="cq-pn">{{ p.refforn ?? p.referencia ?? p.codprod }}</td>
                  <td class="cq-cd">{{ p.condicao || '—' }}</td>
                  <td class="cq-desc">{{ p.descricao }}</td>
                  <td class="cq-un">{{ p.codvol ?? 'UN' }}</td>
                  <td class="cq-est text-right"
                      [class.cq-est-zero]="(p.estoque ?? 0) <= 0">
                    {{ p.estoque != null ? (fmtQtd(p.estoque, p.codvol)) : '—' }}
                  </td>
                  <!-- <td class="cq-preco text-right">{{ p.vlrVenda != null ? (p.vlrVenda | number:'1.2-2':'pt-BR') : '—' }}</td> -->
                  <!-- <td class="cq-preco text-right">{{ valorEmReaisConsulta(p.vlrVenda, p.origemNacional, consultaPecasCotacaoAtual) != null ? (valorEmReaisConsulta(p.vlrVenda, p.origemNacional, consultaPecasCotacaoAtual) | number:'1.2-2':'pt-BR') : '—' }}</td> -->
                  <td class="cq-preco text-right">{{ valorMoedaComIpiConsulta(p, consultaPecasCotacaoAtual) != null ? (valorMoedaComIpiConsulta(p, consultaPecasCotacaoAtual) | number:'1.2-2':'pt-BR') : '—' }}</td>
                  <td class="cq-preco text-right">{{ valorReaisComIpiConsulta(p, consultaPecasCotacaoAtual) != null ? (valorReaisComIpiConsulta(p, consultaPecasCotacaoAtual) | number:'1.2-2':'pt-BR') : '—' }}</td>
                  <td class="cq-preco text-right">{{ p.vlrVenda != null ? (vlrIpiUnitarioConsulta(p, consultaPecasCotacaoAtual) | number:'1.2-2':'pt-BR') : '—' }}</td>
                  <td class="cq-marca">{{ p.marca || '—' }}</td>
                  <td class="cq-origem">
                    <span *ngIf="p.origem" class="origem-badge" [class.origem-badge-nacional]="p.origemNacional">{{ p.origem }}</span>
                    <span *ngIf="!p.origem">—</span>
                  </td>
                  <td class="cq-preco text-right">{{ p.dataUltAtualPreco || '—' }}</td>
                  <td class="cq-preco text-right">{{ p.limitePrazoAtualDias > 0 ? p.limitePrazoAtualDias : '—' }}</td>
                  <td class="cq-alt">{{ p.alternativo || '—' }}</td>
                  <td class="cq-preco text-right">{{ p.codprod ?? '—' }}</td>
                </tr>

                <!-- Separador + alternativos TGFPAL — usa consultaPecasProdutoExpandido (fixo no
                     produto principal) para não recolher quando um alternativo é selecionado. -->
                <ng-container *ngIf="consultaPecasProdutoExpandido === p">
                <!-- Sem linha de "Carregando…": evita o flash de expandir/recolher quando o
                     item nao tem alternativos (causava a tela tremendo). So exibe algo quando
                     a busca termina E ha ao menos 1 alternativo. -->
                <tr *ngIf="!consultaPecasAlternativosCarregando && consultaPecasAlternativos.length > 0"
                    class="cq-alt-sep-row">
                  <td colspan="14">
                    PRODUTOS ALTERNATIVOS
                    <span class="cq-alt-count">{{ consultaPecasAlternativos.length }}</span>
                  </td>
                </tr>
                <tr *ngFor="let a of consultaPecasAlternativos"
                    class="cq-linha cq-alt-linha"
                    [class.cq-linha-sel]="consultaPecasProdutoSelecionado === a"
                    [class.cq-sem-preco]="a.vlrVenda == null || a.vlrVenda <= 0"
                    (click)="selecionarAlternativoConsulta(a)">
                  <td class="cq-pn cq-alt-pn">
                    <span *ngIf="a.substituto === 'S'" class="cq-alt-subst" title="Substituto direto">★</span>
                    {{ a.refforn }}
                  </td>
                  <td class="cq-cd">{{ a.condicao || '—' }}</td>
                  <td class="cq-desc">{{ a.descricao }}</td>
                  <td class="cq-un">{{ a.codvol ?? 'UN' }}</td>
                  <td class="cq-est text-right"
                      [class.cq-est-zero]="!a.estoqueTotal || a.estoqueTotal === 0">
                    {{ a.estoqueTotal > 0 ? (fmtQtd(a.estoqueTotal, a.codvol)) : '0' }}
                  </td>
                  <!-- <td class="cq-preco text-right">{{ a.vlrVenda != null ? (a.vlrVenda | number:'1.2-2':'pt-BR') : '—' }}</td> -->
                  <!-- <td class="cq-preco text-right">{{ valorEmReaisConsulta(a.vlrVenda, a.origemNacional, consultaPecasCotacaoAtual) != null ? (valorEmReaisConsulta(a.vlrVenda, a.origemNacional, consultaPecasCotacaoAtual) | number:'1.2-2':'pt-BR') : '—' }}</td> -->
                  <td class="cq-preco text-right">{{ valorMoedaComIpiConsulta(a, consultaPecasCotacaoAtual) != null ? (valorMoedaComIpiConsulta(a, consultaPecasCotacaoAtual) | number:'1.2-2':'pt-BR') : '—' }}</td>
                  <td class="cq-preco text-right">{{ valorReaisComIpiConsulta(a, consultaPecasCotacaoAtual) != null ? (valorReaisComIpiConsulta(a, consultaPecasCotacaoAtual) | number:'1.2-2':'pt-BR') : '—' }}</td>
                  <td class="cq-preco text-right">{{ a.vlrVenda != null ? (vlrIpiUnitarioConsulta(a, consultaPecasCotacaoAtual) | number:'1.2-2':'pt-BR') : '—' }}</td>
                  <td class="cq-marca">{{ a.marca || '—' }}</td>
                  <td class="cq-origem">
                    <span *ngIf="a.origem" class="origem-badge" [class.origem-badge-nacional]="a.origemNacional">{{ a.origem }}</span>
                    <span *ngIf="!a.origem">—</span>
                  </td>
                  <td class="cq-preco text-right">—</td>
                  <td class="cq-preco text-right">—</td>
                  <td class="cq-alt">{{ a.alternativo || '—' }}</td>
                  <td class="cq-preco text-right">{{ a.codprod ?? '—' }}</td>
                </tr>
              </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div><!-- /cq-lista-area -->

      <!-- Painel de estoque por local + imagem -->
      <div *ngIf="consultaPecasProdutoSelecionado" class="cq-estoque-fixo">
        <div class="cq-estoque-coluna">
          <div class="cq-estoque-titulo">
            Estoque por Local —
            <strong>{{ consultaPecasProdutoSelecionado.refforn ?? consultaPecasProdutoSelecionado.referencia }}
            {{ consultaPecasProdutoSelecionado.descricao }}</strong>
          </div>

          <div class="cq-estoque-scroll">
            <div *ngIf="consultaPecasLocaisCarregando" class="cq-estoque-loading"><app-loading-indicator size="inline"></app-loading-indicator> Carregando estoque…</div>
            <div *ngIf="!consultaPecasLocaisCarregando && consultaPecasLocais.length === 0"
                 class="cq-estoque-empty">
              Sem registros de estoque para esta peça.
            </div>
            <table *ngIf="!consultaPecasLocaisCarregando && consultaPecasLocais.length > 0"
                   class="cq-estoque-tabela">
              <thead>
                <tr>
                  <th class="cq-emp">Empresa</th>
                  <th class="cq-local">Local</th>
                  <th class="cq-num">Total</th>
                  <th class="cq-num">Reservado</th>
                  <th class="cq-num">Disponível</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let loc of consultaPecasLocais"
                    [style.background-color]="corLinhaConsulta(loc.codemp)"
                    [class.cq-row-zero]="(loc.disponivel ?? 0) <= 0">
                  <td class="cq-emp">
                    <span class="cq-emp-cod">{{ loc.codemp }}</span>
                    {{ loc.nomeEmp }}
                  </td>
                  <td class="cq-local">{{ loc.descrLocal }}</td>
                  <td class="cq-num">{{ fmtQtdEstoqueLocal(loc.qtdTotal) }}</td>
                  <td class="cq-num cq-reservado">{{ fmtQtdEstoqueLocal(loc.qtdReservada) }}</td>
                  <td class="cq-num"
                      [class.cq-disp-pos]="(loc.disponivel ?? 0) > 0"
                      [class.cq-disp-zero]="(loc.disponivel ?? 0) <= 0">
                    {{ fmtQtdEstoqueLocal(loc.disponivel) }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="cq-row-total">
                  <td colspan="2">Total</td>
                  <td class="cq-num">{{ fmtQtdEstoqueLocal(consultaTotalLocais('qtdTotal')) }}</td>
                  <td class="cq-num">{{ fmtQtdEstoqueLocal(consultaTotalLocais('qtdReservada')) }}</td>
                  <td class="cq-num">{{ fmtQtdEstoqueLocal(consultaTotalLocais('disponivel')) }}</td>
                </tr>
              </tfoot>
            </table>
          </div><!-- /cq-estoque-scroll -->
        </div><!-- /cq-estoque-coluna -->

        <!-- Imagem do produto selecionado — lado direito -->
        <div class="cq-imagem-coluna">
          <div *ngIf="consultaPecasImagemCarregando" class="cq-imagem-loading"><app-loading-indicator></app-loading-indicator> </div>
          <img *ngIf="!consultaPecasImagemCarregando && consultaPecasImagemUrl"
               [src]="consultaPecasImagemUrl"
               class="cq-imagem-produto"
               alt="Imagem do produto"
               title="Clique para ampliar"
               (click)="abrirPreviewImagemConsulta()">
          <div *ngIf="!consultaPecasImagemCarregando && !consultaPecasImagemUrl" class="cq-imagem-vazia">
            Sem imagem cadastrada
          </div>
          <!-- Miniaturas — só aparece quando o produto tem mais de uma imagem cadastrada -->
          <div class="cq-imagem-miniaturas" *ngIf="!consultaPecasImagemCarregando && consultaPecasImagensExtras.length > 1">
            <img *ngFor="let img of consultaPecasImagensExtras; let i = index"
                 [src]="img"
                 class="cq-imagem-miniatura"
                 [class.ativa]="i === consultaPecasImagemIndexAtivo"
                 alt="Miniatura do produto"
                 (click)="selecionarImagemConsulta(i)">
          </div>
        </div><!-- /cq-imagem-coluna -->
      </div><!-- /cq-estoque-fixo -->

    </div><!-- /cq-body -->

    <div class="cq-footer">
      <!-- Legenda das cores de destaque da tabela -->
      <div class="cq-legenda">
        <span class="cq-legenda-item"><span class="cq-legenda-dot cq-legenda-dot-amarelo"></span>Sem Preço</span>
        <span class="cq-legenda-item"><span class="cq-legenda-dot cq-legenda-dot-vermelho"></span>Preço Desatualizado</span>
      </div>
      <button type="button" class="cq-btn-fechar" (click)="fecharConsultaPecas()">Fechar</button>
    </div>
  </div>
</div>

<!-- ── Preview ampliado da imagem do produto (Consulta de Peças / F7 global) ── -->
<div class="cq-overlay cq-imagem-preview-overlay" *ngIf="consultaImagemPreviewAberta"
     (click)="fecharPreviewImagemConsulta()" (keydown.escape)="fecharPreviewImagemConsulta()">
  <div class="cq-imagem-preview-box" (click)="$event.stopPropagation()">
    <button type="button" class="cq-imagem-preview-fechar" (click)="fecharPreviewImagemConsulta()" title="Fechar">✕</button>
    <div class="cq-imagem-preview-img-wrap">
      <img [src]="consultaPecasImagemUrl" class="cq-imagem-preview-img" alt="Imagem do produto ampliada">
    </div>
    <!-- Miniaturas — só aparece quando o produto tem mais de uma imagem cadastrada -->
    <div class="cq-imagem-preview-miniaturas" *ngIf="consultaPecasImagensExtras.length > 1">
      <img *ngFor="let img of consultaPecasImagensExtras; let i = index"
           [src]="img"
           class="cq-imagem-preview-miniatura"
           [class.ativa]="i === consultaPecasImagemIndexAtivo"
           alt="Miniatura do produto"
           (click)="selecionarImagemConsulta(i)">
    </div>
  </div>
</div>

<!-- ── Modal Impressão de Pedido (nível raiz, fora do content-shell) ── -->
<div class="impressao-overlay" *ngIf="impressaoPedido() != null" (click)="fecharImpressao()">
  <div class="impressao-modal" (click)="$event.stopPropagation()">
    <button
            type="button"
            class="impressao-fechar"
            (click)="fecharImpressao()"
            title="Fechar impressão"
            aria-label="Fechar impressão">
      &times;
    </button>
    <app-gpl-venda-impressao
            *ngIf="impressaoPedido() != null"
            [modoModal]="true"
            (fecharModal)="fecharImpressao()">
    </app-gpl-venda-impressao>
  </div>
</div>

<!-- Impressão de compras: mesmo modal utilizado em vendas. -->
<div class="impressao-overlay" *ngIf="impressaoCompra() as selecao" (click)="fecharImpressaoCompra()">
  <div class="impressao-modal" (click)="$event.stopPropagation()">
    <button type="button" class="impressao-fechar" (click)="fecharImpressaoCompra()"
      title="Fechar impressão" aria-label="Fechar impressão">&times;</button>
    <app-compra-impressao
      [modoModal]="true"
      [nunotaInicial]="selecao.nunota"
      [view]="selecao.view"
      (fecharModal)="fecharImpressaoCompra()">
    </app-compra-impressao>
  </div>
</div>
